var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionParameters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 135,
    viewBox: "0 0 147 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4988 11.0739L16.8488 26.6438L9.52008 26.6437L13.7569 17.9135L3.79883 17.9135L11.4488 2.34381L18.7776 2.34375L14.5407 11.0739L24.4988 11.0739Z",
    stroke: "#B33939",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 63.5571H18.1878V55.4449H10.1122V63.5571H2V71.6327H10.1122V79.7449H18.1878V71.6327H26.3V63.5571Z",
    stroke: "#B33939",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70215 123.054C4.70215 128.484 9.11106 132.845 14.6021 132.845C20.0932 132.845 24.5021 128.484 24.5021 123.054C24.5021 117.623 14.6021 108.545 14.6021 108.545C14.6021 108.545 4.70215 117.662 4.70215 123.054Z",
    stroke: "#B33939",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 43.7021,
    y1: 22.4449,
    x2: 43.7021,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50.9033,
    y1: 22.4449,
    x2: 50.9033,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 58.1035,
    y1: 22.4449,
    x2: 58.1035,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 65.3008,
    y1: 22.4449,
    x2: 65.3008,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 72.501,
    y1: 22.4449,
    x2: 72.501,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 79.7021,
    y1: 22.4449,
    x2: 79.7021,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 86.9033,
    y1: 22.4449,
    x2: 86.9033,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 94.1035,
    y1: 22.4449,
    x2: 94.1035,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 101.301,
    y1: 22.4449,
    x2: 101.301,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 108.501,
    y1: 22.4449,
    x2: 108.501,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 43.7021,
    y1: 77.3445,
    x2: 43.7021,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 50.9033,
    y1: 77.3445,
    x2: 50.9033,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 58.1035,
    y1: 77.3445,
    x2: 58.1035,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 65.3008,
    y1: 77.3445,
    x2: 65.3008,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 72.501,
    y1: 77.3445,
    x2: 72.501,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 79.7021,
    y1: 77.3445,
    x2: 79.7021,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 86.9033,
    y1: 77.3445,
    x2: 86.9033,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 94.1035,
    y1: 77.3445,
    x2: 94.1035,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 94.1035,
    y1: 130.445,
    x2: 94.1035,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 101.301,
    y1: 77.3445,
    x2: 101.301,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 101.301,
    y1: 130.445,
    x2: 101.301,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 108.501,
    y1: 77.3445,
    x2: 108.501,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 108.501,
    y1: 130.445,
    x2: 108.501,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 115.702,
    y1: 77.3445,
    x2: 115.702,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 115.702,
    y1: 22.4449,
    x2: 115.702,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 115.702,
    y1: 130.445,
    x2: 115.702,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 122.903,
    y1: 77.3445,
    x2: 122.903,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 122.903,
    y1: 22.4449,
    x2: 122.903,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 122.903,
    y1: 130.445,
    x2: 122.903,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 130.104,
    y1: 77.3445,
    x2: 130.104,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 130.104,
    y1: 22.4449,
    x2: 130.104,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 130.104,
    y1: 130.445,
    x2: 130.104,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 137.301,
    y1: 77.3445,
    x2: 137.301,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 137.301,
    y1: 22.4449,
    x2: 137.301,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 137.301,
    y1: 130.445,
    x2: 137.301,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 144.501,
    y1: 77.3445,
    x2: 144.501,
    y2: 58.7445,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 144.501,
    y1: 22.4449,
    x2: 144.501,
    y2: 3.84492,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 144.501,
    y1: 130.445,
    x2: 144.501,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 43.7021,
    y1: 130.445,
    x2: 43.7021,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 50.9033,
    y1: 130.445,
    x2: 50.9033,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 58.1035,
    y1: 130.445,
    x2: 58.1035,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 65.3008,
    y1: 130.445,
    x2: 65.3008,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 72.501,
    y1: 130.445,
    x2: 72.501,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 79.7021,
    y1: 130.445,
    x2: 79.7021,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 86.9033,
    y1: 130.445,
    x2: 86.9033,
    y2: 111.845,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionParameters);
export default __webpack_public_path__ + "static/media/subscription-parameters.8ef0d503.svg";
export { ForwardRef as ReactComponent };